export default __webpack_public_path__ + "static/media/img_step_lucia03-03.a65b7753.jpg";